import {Document, Sms} from "@falcon/services";
import FalconHeader from "../../../../components/navigation/FalconHeader";
import FalconFooter from "../../../../components/navigation/FalconFooter";
import {useLocation} from "react-router-dom";
import {PluginTemplates} from "../../../../utils/PluginTemplates";
import * as React from "react";
import {useState, useEffect} from "react";
import SmsBlock from "./SmsBlock";
import DocumentBlock from "./DocumentBlock";
import {usePagination} from "../customHooks/usePagination";
import {CommunicationType} from "./CommunicationType";
import {CommunicationCollection} from "./CommunicationCollection";

function CommunicationArchivePage(): React.JSX.Element {
    const communicationCollection: CommunicationCollection = useLocation().state;
    const isDocumentType: boolean = [
        CommunicationType.ArchivedDocuments,
        CommunicationType.Emails,
    ].includes(communicationCollection.type);
    const pluginTemplates = new PluginTemplates();
    const [direction, setDirection] = useState("desc");
    const [active, setActive] = useState(false);
    const sortedList: any[] = getSortedList();
    const {page, setPage, totalPages, paginatedItems} = usePagination(sortedList, 10);

    useEffect(() => {
        window.scrollTo({top: 0});
    }, []);

    function getSortedList(): any[] {
        if (isDocumentType) {
            return [...communicationCollection.items].sort((a: Document, b: Document) => {
                const diff = new Date(a.date).getTime() - new Date(b.date).getTime();

                return direction === "asc" ? diff : -diff;
            });
        } else {
            return [...communicationCollection.items].sort((a: Sms, b: Sms) => {
                const diff = new Date(a.requested).getTime() - new Date(b.requested).getTime();

                return direction === "asc" ? diff : -diff;
            });
        }
    }

    function renderHeader(): string {
        if (communicationCollection.type === CommunicationType.Emails) {
            return "Emails archive";
        } else if (communicationCollection.type === CommunicationType.SMS) {
            return "SMS archive";
        } else {
            return "Documents archive";
        }
    }

    function sortByDate(): void {
        setDirection(prevState => (prevState === "asc" ? "desc" : "asc"));
        setActive(true);
    }

    function getSortDirection(): string {
        return direction === "asc" ? "fas fa-sort-up" : "fas fa-sort-down";
    }

    function renderSortByDate(): React.JSX.Element {
        return (
            <tr>
                <th className={"pb-3 pl-3"}>
                    <span className="documents-archive-table-header muli-semi-bold-16">
                        Date
                    </span>
                    <button
                        type="button"
                        onClick={sortByDate}
                        className={`table-sort-arrow ${active ? getSortDirection() : "fas fa-sort"}`}
                        aria-label="Sort by date"
                    />
                </th>
            </tr>
        );
    }

    function renderDocuments(paginatedItems: any[]): React.JSX.Element[] {
        return paginatedItems.map((document: Document): React.JSX.Element => (
            <DocumentBlock key={document.id} document={document}/>
        ));
    }

    function renderSms(paginatedItems: any[]): React.JSX.Element[] {
        return paginatedItems.map((sms: Sms): React.JSX.Element => (
            <SmsBlock key={sms.id} sms={sms}/>
        ));
    }

    function renderItems(): React.JSX.Element {
        return (
            <>
                <h1 className={"document-page-header mt-3"}>
                    {renderHeader()}
                </h1>
                <div className="documents-page">
                    <div className={`widget documents-widget panel document-list emails-block borders`}>
                        <table>
                            <tbody>
                            {renderSortByDate()}
                            {isDocumentType
                                ? renderDocuments(paginatedItems)
                                : renderSms(paginatedItems)}
                            </tbody>
                        </table>
                        {communicationCollection.items.length > 10 && (
                            <div className="pagination">
                                <button
                                    className="pagination-btn"
                                    disabled={page === 1}
                                    onClick={() => setPage(page - 1)}
                                >
                                    ← Previous
                                </button>

                                <span className="pagination-info">
                                    <strong>{page}</strong> of {totalPages}
                                </span>

                                <button
                                    className="pagination-btn"
                                    disabled={page === totalPages}
                                    onClick={() => setPage(page + 1)}
                                >
                                    Next →
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            </>
        );
    }

    return (
        <>
            <FalconHeader/>
            <div className="plugin">
                {pluginTemplates.renderBackLink("Back", true)}
                {renderItems()}
                {pluginTemplates.renderBackLink("Back", false)}
                <FalconFooter/>
            </div>
        </>
    );
}

export default CommunicationArchivePage;
